export const getPenolaData = () => ({
  name: "Penola",
  country: "Australie",
  region: "Coonawarra",
  description: "Penola est une sous-région méridionale de Coonawarra, connue pour ses vins rouges structurés et ses blancs frais. Ses sols terra rossa et son climat frais créent des conditions idéales pour des vins de grande finesse.",
  type: "subregion",
  mapAreas: [
    { region: "Penola", x: 38, y: 85, color: "#e2c2e2", size: 2 }
  ],
  statistics: {
    totalArea: "1,000 ha",
    production: "0.05 million hectolitres",
    altitude: "50-100m",
    appellations: "Penola GI",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat frais avec étés chauds et secs, hivers froids, influence océanique",
    soil: "Sols terra rossa et argileux, excellente drainage",
    viticulture: "Viticulture moderne, qualité privilégiée, rendements limités"
  },
  wineStyles: {
    red: "Cabernet Sauvignon structurés et complexes, Shiraz élégants, assemblages équilibrés",
    white: "Chardonnay frais et aromatiques, Sauvignon Blanc élégants, Riesling complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "Penola s'est développée comme sous-région distincte dans les années 1990. La sous-région s'est rapidement imposée pour ses vins de qualité et ses sols terra rossa.",
  foodPairing: "Cuisine australienne : viandes rouges, volailles, fromages affinés, cuisine traditionnelle.",
  grapeVarieties: {
    white: ["Chardonnay", "Sauvignon Blanc", "Riesling"],
    red: ["Cabernet Sauvignon", "Shiraz", "Merlot"]
  },
  keyProducers: ["Wynns", "Parker Coonawarra", "Balnaves"],
  notableWines: {
    "cabernet-sauvignon": "Cabernet Sauvignon structurés et complexes",
    "shiraz": "Shiraz élégants et équilibrés",
    "chardonnay": "Chardonnay frais et aromatiques"
  }
}); 